import { FaqItem, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getFAQ = async (
  groupId: number,
  faqCode: string,
  locale: string
): Promise<FaqItem | null> => {
  try {
    const url = `/group/${groupId}/${SubEntityType.FrequentlyAskedQuestions}/${faqCode}?marketLocale=${encodeURIComponent(locale)}`;

    const response = await knowledgeBaseHttp.get<FaqItem>(url);
    return response?.data || null;
  } catch (error) {
    throw new Error(`Error fetching FAQ: ${error}`);
  }
};
